const base = {
    component: 'OriginList',
    init: true,
    originOption: 'data-code',
    selectedClass: 'selected'
};

const configuration = {
    logitravel: {
        ...base,
        ...{
            endpoint: '/mybookings/origin/setorigin',
            parameterName: 'airportcode',
            verb: 'post'
        }
    }
};

module.exports = function fn(type = 'logitravel') {
    return configuration[type] || base;
};
